<div
  class="inline-flex items-center rounded-xl border border-foreground overflow-hidden text-sm bg-secondary"
>
  <label
    class="cursor-pointer px-4 py-2 select-none transition-colors rounded-xl"
    [class.bg-primary]="selectedOption === 'today'"
    [class.text-white]="selectedOption === 'today'"
    [class.text-primary]="selectedOption !== 'today'"
    (click)="onSelect('today')"
  >
    Hoje
  </label>

  <label
    class="cursor-pointer px-4 py-2 select-none transition-colors rounded-xl"
    [class.bg-primary]="selectedOption === 'week'"
    [class.text-white]="selectedOption === 'week'"
    [class.text-primary]="selectedOption !== 'week'"
    (click)="onSelect('week')"
  >
    Semana
  </label>

  <label
    class="cursor-pointer px-4 py-2 select-none transition-colors rounded-xl"
    [class.bg-primary]="selectedOption === 'month'"
    [class.text-white]="selectedOption === 'month'"
    [class.text-primary]="selectedOption !== 'month'"
    (click)="onSelect('month')"
  >
    Mês
  </label>
</div>
